
import { v4 as uuid } from 'uuid'

export class MCOption {
  id: number  
  name: string
  sort_order: number

  constructor() { 
  }

  static buildOne(obj: any): MCOption {
    let target: MCOption = Object.assign(new MCOption(), obj)
    return target
  }

  static buildMany(objs: any[]): MCOption[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(MCOption.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

export class ShowIfQuestion {
  question_id: number  
  show_if_question_id: number
  show_if_data: string

  constructor() { 
  }

  static buildOne(obj: any): ShowIfQuestion {
    let target: ShowIfQuestion = Object.assign(new ShowIfQuestion(), obj)
    return target
  }

  static buildMany(objs: any[]): ShowIfQuestion[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(ShowIfQuestion.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

export class Question {
  id: number  
  name: string
  sort_order: number
  data_type: string
  min: number
  max: number  
  is_required: boolean
  is_na_allowed: boolean
  is_na_selected: boolean
  is_visible: boolean
  options: MCOption[]  
  show_if_questions: ShowIfQuestion[]
  answer: string
  answers: string[]

  constructor() { 
  }

  static buildOne(obj: any): Question {
    let target: Question = Object.assign(new Question(), obj)
    return target
  }

  static buildMany(objs: any[]): Question[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(Question.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

export class ProjectQuestionData {
  project_id: number  
  project_name: string
  questions: Question[]

  constructor() { 
  }

  static buildOne(obj: any): ProjectQuestionData {
    let target: ProjectQuestionData = Object.assign(new ProjectQuestionData(), obj)
    return target
  }

  static buildMany(objs: any[]): ProjectQuestionData[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(ProjectQuestionData.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}


export class Survey {
  uuid: string
  id: number  
  user_id: number  
  store_id: number
  survey_date: string
  latitude: number
  longitude: number
  project_question_data: ProjectQuestionData[]
  is_pending_save: boolean
  is_pending_delete: boolean

  constructor() { 
  }

  public async setViewModelFields()
  {
    if (!this.id) {
      this.id = 0
    }
    if (!this.uuid) {
      this.uuid = uuid();
    }
    if (this.is_pending_save === undefined) {
      this.is_pending_save = false
    }
    if (this.is_pending_delete === undefined) {
      this.is_pending_delete = false
    }
  }

  static buildOne(obj: any): Survey {
    let target: Survey = Object.assign(new Survey(), obj)  
    target.setViewModelFields()
    return target
  }

  static buildMany(objs: any[]): Survey[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(Survey.buildOne(objs[i]))
      }
    }
    return lobjs
  }

  static removeInVisibleQuestions(survey: Survey): Survey {
    for (const pq of survey.project_question_data) {
      pq.questions = pq.questions.filter(q => q.is_visible)
    }
    return survey
  }
}

